__turbopack_context__.v({
  "baseClass": "BpJW2a_baseClass",
  "h1": "BpJW2a_h1",
  "h2": "BpJW2a_h2",
  "h3": "BpJW2a_h3",
  "h4": "BpJW2a_h4",
  "h5": "BpJW2a_h5",
  "h6": "BpJW2a_h6",
});
